// Sélecteur de TVA unifié (mêmes taux partout : 20 / 10 / 5,5 / 0 %)
export const TVA_OPTIONS = [20, 10, 5.5, 0] as const;

export const tvaLabel = (v: number) => `${String(v).replace('.', ',')} %`;

type Props = {
  value: number | string;
  onChange: (v: number) => void;
  className?: string;
  id?: string;
};

export function TvaSelect({ value, onChange, className, id }: Props) {
  const current = String(Number(value ?? 20));
  return (
    <select
      id={id}
      value={current}
      onChange={(e) => onChange(Number(e.target.value))}
      className={
        className ??
        'w-full px-3 py-2 bg-slate-950/60 border border-slate-800 rounded-lg text-sm text-slate-200 focus:outline-none focus:border-amber-500/50'
      }
    >
      {TVA_OPTIONS.map((o) => (
        <option key={o} value={String(o)}>
          {tvaLabel(o)}
        </option>
      ))}
    </select>
  );
}

export default TvaSelect;
